export const integerFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
});

export const COMPACT_NUMBER_FORMATTER = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

// CTR and VCR are returned by the API as pre-multiplied percentages
// (e.g. 1.23 means 1.23%) — do NOT use style: "percent", which would
// multiply by 100 again and render 1.23 as "123.00%".
const percentageFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export const cpmFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const fmt = (
  n: number | null | undefined,
  formatter: Intl.NumberFormat
): string => (n == null ? "—" : formatter.format(n));

export const fmtPct = (n: number | null | undefined): string =>
  n == null ? "—" : `${percentageFormatter.format(n)}%`;

export const fmtStr = (s: string | null | undefined): string => s || "—";

// avg_dwell_time_min is fractional minutes. Format with explicit unit labels
// so the value is unambiguous: "24s" under a minute, "1m 24s" at a minute+.
export const fmtDwell = (n: number | null | undefined): string => {
  if (n == null) return "—";
  const totalSec = Math.round(n * 60);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return m === 0 ? `${s}s` : `${m}m ${s}s`;
};

export const CSV_ESCAPE = (v: string): string => {
  // Escape leading characters that spreadsheets treat as formula prefixes.
  const safe = /^[=+\-@\t\r]/.test(v) ? `'${v}` : v;
  // Quote if the value contains special characters; escape quotes by doubling.
  return safe.includes(",") ||
    safe.includes('"') ||
    safe.includes("\n") ||
    safe.includes("\r") ||
    safe.includes("\t")
    ? `"${safe.replace(/"/g, '""')}"`
    : safe;
};

// 0 is PrimeReact's special "show all rows" value — the paginator's slice
// condition is rows > 0, so rows=0 bypasses pagination entirely.
export const RPP_OPTIONS = [
  { label: "25", value: 25 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "All", value: 0 },
];
